import { render, staticRenderFns } from "./WinnerBoardPastWinners.vue?vue&type=template&id=7ba8dddc&scoped=true"
import script from "./WinnerBoardPastWinners.vue?vue&type=script&lang=js"
export * from "./WinnerBoardPastWinners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8dddc",
  null
  
)

export default component.exports